import React from 'react';
import {Button, Col} from 'antd';
import {AppRowContainer} from '../../../@crema';
import './index.style.less';
import {
  useAuthUser,
  usePatchUserVerification,
} from '../../../@crema/utility/AuthHooks';
import {useOpenNotification} from '../../../utility/hooks/NotificationHooks';

const NeedUserEmailVerification = () => {
  const user = useAuthUser();
  const {patchUserVerification} = usePatchUserVerification();
  const {openSuccessNotification, openErrorNotification} =
    useOpenNotification();

  const onButtonClick = () => {
    patchUserVerification()
      .then(() => {
        openSuccessNotification('Confirmation link has been sent on email!');
      })
      .catch(() => {
        openErrorNotification('Error during creating confirmation link!');
      });
  };

  return (
    <div className={'page-content-holder'}>
      <h2 className={'page-content-header'}>Need to verify email address</h2>
      <AppRowContainer gutter={16}>
        <Col xs={24} md={24}>
          <div className={'need-email-verification'}>
            You email {user.user.email} is not verified
          </div>
          <div className={'need-email-verification__msg'}>
            We have sent you an email with a verification link. Please check
            your email and click on the verification link to complete your
            account activation. If you don&apos;t see the email, be sure to
            check your spam folder - if might be hiding there :)
          </div>
          <div>
            <p>
              If you still can&apos;t find the email in your inbox or spam
              folder, use the Resend button. Please note that there might be a
              few minutes delay before the email arrives.
            </p>
          </div>
        </Col>
        <Col xs={24} md={24}>
          <div className={'resend-btn__container'}>
            <Button
              className={'resend-btn'}
              type={'primary'}
              onClick={onButtonClick}>
              Resend
            </Button>
          </div>
        </Col>
      </AppRowContainer>
    </div>
  );
};

export default NeedUserEmailVerification;
